<template>
  <div class="login" style="height: 100%;position: fixed;top:0;left: 0;width: 100%;min-height: 100vh;display: flex;flex-direction: column;">
    <div class="quick-alert" style="flex: 1;">
      <Quick></Quick>
    </div>
    <div class="signIn-alert" style="display: none;flex: 1;">
      <SignIn></SignIn>
    </div>
    <div class="third" v-if="thirdParty">
      <Thirdparty></Thirdparty>
    </div>
  </div>
</template>

<script>
  import quick from './loginAlert/quick.vue'
  import signIn from './loginAlert/signIn.vue'
  import thirdparty from './loginAlert/thirdparty.vue'
  export default {
    data (){
    return {
      //thirdParty: navigator.userAgent.toLowerCase().indexOf('micromessenger') != -1? false : true
      thirdParty: true
    }
  },
  methods: {
    //操作按钮事件
  },
  components:{   //渲染页面
    Quick: quick,
    SignIn: signIn,
    Thirdparty: thirdparty
  },
  created: function(){
  },
  mounted: function () {
    //操作DOM
    var that = this;
    function ready() {
      if(window.__wxjs_environment === 'miniprogram'){
        that.thirdParty = false;
      }
    }
    if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      document.addEventListener('WeixinJSBridgeReady', ready, false)
    } else {
     ready()
    }
  }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/loginAler.vue